const FISTO_TAGS = {
  DEBTORS_RANKING: 'DEBTORS_RANKING',
  LATEST_MANUAL_TGR: 'LATEST_MANUAL_TGR',
  CREDIT_LINE_APPLICATION_HISTORY: 'CREDIT_LINE_APPLICATION_HISTORY',
  CLIENT_BALANCES: 'CLIENT_BALANCES',
} as const;

type FistoTag = (typeof FISTO_TAGS)[keyof typeof FISTO_TAGS];

const ALL_TAGS: FistoTag[] = [
  FISTO_TAGS.DEBTORS_RANKING,
  FISTO_TAGS.LATEST_MANUAL_TGR,
  FISTO_TAGS.CREDIT_LINE_APPLICATION_HISTORY,
  FISTO_TAGS.CLIENT_BALANCES,
] as const;

export { ALL_TAGS, FISTO_TAGS };
